import {useEffect, useState} from 'react';
import './home.scss';
import {useTranslation} from "react-i18next";
import earringsAndHeadband from "../../../assets/images/home/earrings_and_headband.jpeg"
import {getHomeSlidingPhotos} from "../../../api/api";
import {API_URL} from "../../../constants/constants";
import {HomeSlidingPhoto} from "../../../interfaces/interfaces";

const Home = () => {
    const {t} = useTranslation()
    const [images, setImages] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const words = [
        t("home.sorority"), t("home.beauty-elsewhere"), t("home.creativity"), t("home.humanity"),
        t("home.joy"), t("home.self-esteem"), t("home.relationship"), t("home.pleasure"),
        t("home.sharing"), t("home.confidence"), t("home.peace"), t("home.handmade"),
    ]
    const [lightbox, setLightbox] = useState<{ open: boolean; slides: string[]; index: number }>({
        open: false,
        slides: [],
        index: 0,
    });

    const handleImageClick = (img: HomeSlidingPhoto, i: number) => {
        if (!img?.photos.length) return;
        setLightbox({
            open: true,
            slides: img.photos.map(p => `${API_URL}${p.imageUrl}`),
            index: i,
        });
    };

    const closeLightbox = () => setLightbox(prev => ({ ...prev, open: false }));
    useEffect(() => {
        setLoading(true);
        getHomeSlidingPhotos(true).then(setImages).catch(console.error);
        setLoading(false);
    } ,[]);

    const prev = () => setLightbox(prev => ({
        ...prev,
        index: (prev.index - 1 + prev.slides.length) % prev.slides.length,
    }));

    const next = () => setLightbox(prev => ({
        ...prev,
        index: (prev.index + 1) % prev.slides.length,
    }));

    useEffect(() => {
        const handler = (e: KeyboardEvent) => {
            if (!lightbox.open) return;
            if (e.key === 'Escape') closeLightbox();
            if (e.key === 'ArrowLeft') prev();
            if (e.key === 'ArrowRight') next();
        };
        window.addEventListener('keydown', handler);
        return () => window.removeEventListener('keydown', handler);
    }, [lightbox.open]);

    return (
        <div className={"Home"}>
            <div className={"textes-wrapper"}>
                <div className={"section"}>
                    <div className={"section-paragraph"}>
                        <div className="marquee-to-left">
                            <div className="marquee-track">
                                {!loading ? (
                                    <>
                                        {[...images, ...images].map((img, i) => (
                                            <img
                                                key={i}
                                                src={`${API_URL}${img.imageUrl}`}
                                                alt={img.name}
                                                onClick={() => handleImageClick(img, 0)}
                                            />
                                        ))}
                                    </>
                                ) : (
                                    <div>{t("gallery.loading")}</div>
                                )}
                            </div>
                        </div>
                        <div className="marquee-to-right">
                            <div className="marquee-track">
                                {[...words, ...words, ...words, ...words].map((word, i) => (
                                    <p key={i}>{word}</p>
                                ))}
                            </div>
                        </div>
                        <div className={"home-main-image"}>
                            <img src={earringsAndHeadband} alt="" height={200} />
                        </div>
                    </div>
                </div>
            </div>
            {lightbox.open && (
                <div
                    className="lightbox-overlay"
                    onClick={closeLightbox}
                >
                    <div className="lightbox-content" onClick={e => e.stopPropagation()}>
                        <button className="lightbox-close" onClick={closeLightbox}>✕</button>
                        <button className="lightbox-prev" onClick={prev}>‹</button>
                        <img src={lightbox.slides[lightbox.index]} alt="" />
                        <button className="lightbox-next" onClick={next}>›</button>
                        <span className="lightbox-counter">
                {lightbox.index + 1} / {lightbox.slides.length}
            </span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Home;
